module.exports = __webpack_public_path__ + "static/media/anz.d68e774e.png";